// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2306":"css/app.6975","3505":"css/admin-app.6975"}[chunkId] + ".css";
};